import {
  Box,
  TextField,
  Typography,
  Button,
  IconButton,
  Paper,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const EndpointStep = ({ website }) => {
  const endpoint = `POST https://api.yourcrm.com/v1/leads/${website.endpointId}`;

  const payload = `{
  "name": "John Doe",
  "email": "john@example.com",
  "phone": "9876543210",
  "message": "Interested in your service",
  "secret": "${website.secret}"
}`;

  const copy = (text) => navigator.clipboard.writeText(text);

  return (
    <Box display="grid" gap={3}>
      {/* Endpoint URL */}
      <Box>
        <Typography fontWeight={600} mb={1}>
          API Endpoint
        </Typography>

        <Paper
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: "#f7f9fc",
            border: "1px solid #e0e6ed",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <Typography
            fontFamily="monospace"
            fontSize="0.9rem"
            sx={{
              wordBreak: "break-all",
            }}
          >
            {endpoint}
          </Typography>

          <IconButton
            size="small"
            onClick={() => copy(endpoint)}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <ContentCopyIcon fontSize="small" />
          </IconButton>
        </Paper>
      </Box>

      {/* Secret Key */}
      <Box>
        <Typography fontWeight={600} mb={1}>
          Secret Key
        </Typography>

        <Paper
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: "#f7f9fc",
            border: "1px solid #e0e6ed",
            position: "relative",
          }}
        >
          <Typography
            fontFamily="monospace"
            fontSize="0.9rem"
            sx={{ wordBreak: "break-all" }}
          >
            {website.secret}
          </Typography>

          <IconButton
            size="small"
            onClick={() => copy(website.secret)}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <ContentCopyIcon fontSize="small" />
          </IconButton>
        </Paper>
      </Box>

      {/* Sample Payload */}
      <Box>
        <Typography fontWeight={600} mb={1}>
          Sample Payload (JSON)
        </Typography>

        <Paper
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: "#1e1e1e",
            color: "#fff",
            border: "1px solid #333",
            position: "relative",
          }}
        >
          <pre
            style={{
              margin: 0,
              fontFamily: "monospace",
              fontSize: "0.85rem",
              overflowX: "auto",
            }}
          >
            {payload}
          </pre>

          <IconButton
            size="small"
            onClick={() => copy(payload)}
            sx={{ position: "absolute", top: 8, right: 8, color: "#fff" }}
          >
            <ContentCopyIcon fontSize="small" />
          </IconButton>
        </Paper>
      </Box>

      <Button
        variant="contained"
        sx={{ mt: 1, borderRadius: 2, py: 1.2 }}
        onClick={() => copy(`${endpoint}\n\n${payload}`)}
      >
        Copy All Details
      </Button>
    </Box>
  );
};

export default EndpointStep;
